import { render } from "./RMARequest.vue?vue&type=template&id=7bdaf2da&scoped=true"
import script from "./RMARequest.vue?vue&type=script&lang=js"
export * from "./RMARequest.vue?vue&type=script&lang=js"

import "./RMARequest.vue?vue&type=style&index=0&id=7bdaf2da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdaf2da"]])

export default __exports__